import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-f98d9094")

_pushScopeId("data-v-f98d9094")
const _hoisted_1 = { class: "p-16" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "pb-10 text-4xl font-bold " }, "The Story", -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("p", null, " Treasure loves her best friend, Annie. One day, Annie hears some sad news -- Annie's family is moving. Annie is worried that she won't have any friends in the new neighborhood, and her birthday is only two weeks away! ", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("p", null, " Treasure can sense that Annie is sad. She tries hard to make Annie happy, but without friends, it will be a very lonely birthday party. ", -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("p", null, "Can Treasure help Annie make new friends? Of course -- Treasure has a plan!", -1)
const _hoisted_6 = { class: "p-16" }
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "pb-10 text-4xl font-bold" }, "About the Book", -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("p", null, " Treasure's Gift is published as a quality hardcover book, with durable pages. I wanted a a high-quality book that is meant to be read over and over again. It's slightly larger than most children's books, which makes it easier for young hands to hold and read. ", -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("p", null, " Treasure's Gift is a fully illustrated chapter book, with 36 pages divided into seven chapters. The story is written for readers in first or second grade, and can be enjoyed by young children of all ages. The main characters in the story are Annie, a young girl, and her very special friend Treasure, a Golden Retriever. It captures the essence of that special bond that you have when you grow up with a dog in the family. ", -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("p", null, " This story will appeal to youngsters who loves dogs (especially Golden Retrievers) and anyone who had a very special dog in their life. ", -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("p", null, " Each book will be signed by the author, and you can have a special dedication to the child you're giving the book to. Imagine giving a special gift with a message from the author, addressed to your child or grandchild! ", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_quote_box = _resolveComponent("quote-box")
  const _component_box = _resolveComponent("box")
  const _component_buy_button = _resolveComponent("buy-button")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_quote_box, {
      body: "What a wonderful book! We gave to a lovely, and lively, little girl on Christmas Eve. She sat still on her grandma's lap and insisted that Grandma read it over and over. She simply loved it!",
      author: "Stephanie"
    }),
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_box, { class: "p-5 bg-white" }, {
        default: _withId(() => [
          _hoisted_2,
          _hoisted_3,
          _hoisted_4,
          _hoisted_5
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_quote_box, {
      body: "I've purchased two of these books and given them to young children as gifts. They were in love with the book. I was sent videos of the kids with the books and they are just so sweet. Wonderfully written and illustrated.",
      author: "Mark"
    }),
    _createVNode("div", _hoisted_6, [
      _createVNode(_component_box, { class: "p-5 bg-white" }, {
        default: _withId(() => [
          _hoisted_7,
          _hoisted_8,
          _hoisted_9,
          _hoisted_10,
          _hoisted_11,
          _createVNode(_component_buy_button, { label: "Buy 'Treasure's Gift'" })
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_quote_box, {
      body: "I gave this book to the children of 3 of my friends and they all said it was the \"best gift ever!\" Parents loved it too! and said the children keep reading it over and over!",
      author: "Susan"
    })
  ]))
})